import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers';
import { createReducer } from './utils';

import {
  INTERNAL_LIBRARIES_FAILURE,
  INTERNAL_LIBRARIES_LOADING,
  INTERNAL_LIBRARIES_SUCCESS,
  SNACK_SET,
} from './constants';

const defaultState = {
  catalog: null,
  loading: false,
  error: null,
};

export const reducer = createReducer(defaultState, {
  [INTERNAL_LIBRARIES_LOADING]: handleRequest,
  [INTERNAL_LIBRARIES_SUCCESS]: handleAvailable,
  [INTERNAL_LIBRARIES_FAILURE]: handleUnavailable,
});

export function fetchInternalLibraryCatalog() {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'catalog';
    const loadingName = 'loading';
    dispatch({ type: INTERNAL_LIBRARIES_LOADING, payload: { loadingName } });
    try {
      const response = await dataSource.getInternalLibraryCatalog();
      dispatch({
        type: INTERNAL_LIBRARIES_SUCCESS,
        payload: { keyState, data: response, loadingName },
      });
    } catch (error) {
      console.log('error fetching internal library catalog:', error);
      dispatch({
        type: INTERNAL_LIBRARIES_FAILURE,
        payload: { keyState, loadingName, defaultState: null },
      });
      const snack = {
        open: true,
        message: 'Could not load the library catalog. Showing local fixture instead.',
        severity: 'warning',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}
